/**
 * Переинициализация слайдеров при открытии аккордеона
 * Это нужно для корректной работы слайдеров, которые были скрыты при загрузке страницы
 */

import { onDomReady } from '../../components/dynamic/observer';

onDomReady(() => {
  // Слушаем событие открытия элементов аккордеона
  const accordionElements = document.querySelectorAll('[data-switchable-accordion-element]');

  if (!accordionElements.length) {
    return;
  }

  accordionElements.forEach((accordionElement) => {
    accordionElement.addEventListener('ElementOpen', () => {
      // Задержка для завершения CSS переходов
      setTimeout(() => {
        const sliders = accordionElement.querySelectorAll('[data-switchable-slider-container]');

        sliders.forEach((sliderContainer) => {
          // Слайдер уже инициализирован MyTinySlider, при открытии аккордеона
          // достаточно вызвать refresh(), чтобы пересчитать размеры без повторной обёртки DOM
          // eslint-disable-next-line no-underscore-dangle
          const sliderInstance = sliderContainer._tnsSlider; // свойство задаётся в MyTinySlider

          if (sliderInstance && typeof sliderInstance.refresh === 'function') {
            sliderInstance.refresh();
          }
        });
      }, 350);
    });
  });
});